import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import Modal from '../../common/modals/Modal'
import Button from '../../common/form/inputs/Button'
import { PersonDto } from '../../../api/person/models/PersonDto'
import {
    getCountryFlag,
    getProfilePicUrl,
    formatPersonName,
} from '../../../utils/personUtils'

interface Props {
    person: PersonDto
    onClose: () => void
    onShowInFuture: () => void
    onDontShowAgain: () => void
}

export default function NotAFitModal({
    person,
    onClose,
    onShowInFuture,
    onDontShowAgain,
}: Props): React.JSX.Element {
    return (
        <Modal onClose={onClose} size="medium">
            {/* mt-8 to ensure the content doesn't hit into the top right close (X) button on the modal */}
            <div className="mt-8">
                <div className="flex items-center gap-4">
                    {/* Avatar + reserved space */}
                    <div className="flex items-center justify-start w-[60px] flex-shrink-0 relative">
                        <img
                            src={
                                getProfilePicUrl(person) ||
                                '/no-profile-pic.svg'
                            }
                            alt={formatPersonName(person)}
                            className="w-[60px] h-[60px] object-cover rounded-full shrink-0"
                            onError={(e) => {
                                e.currentTarget.onerror = null
                                e.currentTarget.src = '/no-profile-pic.svg'
                            }}
                        />
                    </div>

                    {/* Text content */}
                    <div className="flex flex-col self-center flex-1">
                        <div className="line-clamp-1 font-bold">
                            {formatPersonName(person)}
                        </div>

                        <div className="text-sm text-gray-500 mt-2">
                            <div className="flex mt-[-0.5rem] flex-col">
                                <div className="line-clamp-2">
                                    {person?.headline}
                                </div>
                                <div className="text-gray-600 text-sm line-clamp-1">
                                    {getCountryFlag(
                                        person?.location
                                            ?.split(',')
                                            .pop()
                                            ?.trim() ?? '',
                                    )}
                                    <span className="ml-2">
                                        {person?.location}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-4 px-2 my-4 text-gray-800 text-base font-bold border-b border-t">
                    Would you consider {person.firstName} for future roles?
                </div>
                <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <Button
                        style="primary"
                        type="button"
                        classes="w-full sm:flex-1"
                        onClick={onShowInFuture}
                    >
                        <span className="flex items-center justify-center gap-2">
                            <FontAwesomeIcon icon={faCheckCircle} />
                            <span>Show in Future</span>
                        </span>
                    </Button>

                    <Button
                        style="danger"
                        type="button"
                        classes="w-full sm:flex-1"
                        onClick={onDontShowAgain}
                    >
                        <span className="flex items-center justify-center gap-2">
                            <FontAwesomeIcon icon={faXmarkCircle} />
                            <span>Don't Show this Person Again</span>
                        </span>
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
